import { render, staticRenderFns } from "./Resources.vue?vue&type=template&id=ca65574c&scoped=true&lang=html&"
import script from "./Resources.vue?vue&type=script&lang=js&"
export * from "./Resources.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca65574c",
  null
  
)

export default component.exports